<template>
  <div 
    class="com-screenshot"
    v-bg="`url(${config.screen_shot_bg}) no-repeat 0 0 / 100% auto`"
  >
    <div class="user-info">
      <div class="avatar-wrapper">
        <img v-src="config.user_info.avatar" alt="" class="avatar">
      </div>
      <p 
        class="username"
        :style="{
          'color': config.share_content_color
        }"
      >{{ config.user_info.username }}</p>
      <p 
        class="desc"
        :style="{
          'color': config.share_content_color
        }"
      >{{ config.share_content_desc }}</p>
    </div>
    <div class="card-wrapper card-container">
      <div class="card-item">
        <img class="main-card" v-src="config.share_card_img" alt="">
      </div>
    </div>
    <div 
      class="bottom-wrapper"
      :style="{
        'background-color': config.prize_list && config.prize_list.length ? hexToRgba(config.share_prize_area_bg, 0.6) : ''
      }"
    >
      <p 
        class="bottom-title"
        :style="{
          'color': config.share_prize_desc_color
        }"
      >更多大奖等你抽取</p>
      <div class="card-container">
        <div class="card-item" v-for="item in config.prize_list" :key="item.award_id">
          <img class="main-card" v-src="item.img" alt="">
        </div>
      </div>
      <p 
        class="bottom-desc"
        :style="{
          'color': config.share_prize_desc_color
        }"
        v-html="config.share_prize_desc"
      ></p>
    </div>
  </div>
</template>
<script>
import { hexToRgba } from '_lib/utils'
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    hexToRgba: hexToRgba
  }
}
</script>
<style lang="less">
  .com-screenshot {
    max-width: 335px;
    height: 522px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 122px;
    position: relative;
    .user-info {
      width: 289px;
      display: flex;
      justify-content: center;
      align-items: center;
      .avatar-wrapper {
        width: 18px;
        height: 18px;
        border: 1px solid #A4C0FF;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        .avatar {
          width: 100%;
          height: 100%;
        }
      }
      .username {
        font-size: 12px;
        font-weight: 500;
        line-height: 17px;
        margin-left: 11px;
        color: #E8EBFF;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .desc {
        font-size: 10px;
        line-height: 13px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 11px;
        color: #E8EBFF;
      }
    }
    .card-wrapper {
      width: 335px;
      height: 335px;
      position: absolute;
      top: 122px;
      left: 0;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        background: left top / 100% 100% url(https://imgheybox.max-c.com/oa/2023/04/18/61a95696cf653a41f36642753b0da56a.png);
        opacity: 0.8;
        pointer-events: none;
      }
      .card-item {
        width: 127px;
        height: 172px;
        margin: 28px auto 0;
        position: relative;
        z-index: 3;
        .main-card {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom-wrapper {
      width: 100%;
      height: 190px;
      padding-top: 10px;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 3;
      .bottom-title, .bottom-desc {
        line-height: 14px;
        text-align: center;
        font-size: 10px;
        font-weight: 500;
        color: #F9FFB1;
      }
      .bottom-desc {
        margin-top: 10px;
      }
      .card-container {
        height: 116px;
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        .card-item {
          width: 85px;
          height: 116px;
          & + .card-item {
            margin-left: 10px;
          }
          .main-card {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>